import React, { useEffect } from 'react';

/** Velopulse 通用浮層（手機寬為全屏） */
export default function VpModal({ title, onClose, children }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="vp-modal-mask" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="vp-modal" role="dialog" aria-modal="true" aria-label={title}>
        <div className="vp-modal-head">
          <h2>{title}</h2>
          <button type="button" className="vp-modal-x" onClick={onClose} aria-label="關閉">✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}
